import styled from 'styled-components';

export const qr = styled.button`
    flex: 1 1 auto;
    min-height: 0;
    aspect-ratio: 1;
    width: auto;
    height: auto;
    max-width: 200px;
    max-height: 200px;
    overflow: clip;
    padding: 0;
    border: none;
    background: transparent;
    cursor: zoom-in;
    display: block;

    canvas {
        width: 100%;
        height: 100%;
        display: block;
    }
`;
